import { defineComponent, ref, onMounted } from 'vue'
import { getUserList, deleteUser, updateUserRole } from './api'

export default defineComponent({
  name: 'UsersView',
  setup() {
    console.log('UsersView组件初始化')
    
    const userList = ref([])
    const currentPage = ref(1)
    const totalPages = ref(1)
    const searchQuery = ref('')
    const pageSize = ref(10)
    const loading = ref(false)

    // 获取用户列表
    const fetchUserList = async () => {
      console.log('开始获取用户列表数据')
      try {
        loading.value = true
        const params = {
          page: currentPage.value,
          page_size: pageSize.value,
          search: searchQuery.value
        }
        console.log('请求参数:', params)
        
        console.log('发送请求前...')
        const response = await getUserList(params)
        console.log('获取到响应:', response)
        
        if (response.status === 403) {
          console.warn('权限检查失败')
          alert('权限不足，请确认是否为管理员账号')
          return
        }
        userList.value = response.data.data || []
        totalPages.value = response.data.total_pages || 1
        currentPage.value = response.data.page || 1
        console.log('数据更新完成', {
          listLength: userList.value.length,
          totalPages: totalPages.value,
          currentPage: currentPage.value
        })
      } catch (error) {
        console.error('获取用户列表失败，详细错误:', error)
        alert('获取用户列表失败，请稍后重试')
      } finally {
        loading.value = false
        console.log('请求结束，loading状态:', loading.value)
      }
    }

    // 处理页码变化
    const handlePageChange = (page) => {
      console.log('页码变化:', page)
      currentPage.value = page
      fetchUserList()
    }

    // 处理搜索
    let searchTimer = null
    const handleSearch = () => {
      console.log('搜索输入:', searchQuery.value)
      if (searchTimer) {
        clearTimeout(searchTimer)
      }
      searchTimer = setTimeout(() => {
        currentPage.value = 1
        fetchUserList()
      }, 300)
    }

    // 处理角色更新
    const handleUpdateRole = async (user) => {
      console.log('更新用户角色:', user)
      const isCurrentlyAdmin = user.role === 'admin'
      const newRole = isCurrentlyAdmin ? '普通用户' : '管理员'
      const newRoleValue = isCurrentlyAdmin ? 0 : 1
      
      if (confirm(`确定要将用户 "${user.nickname}" 的角色切换为${newRole}吗？`)) {
        try {
          loading.value = true
          await updateUserRole(user.id, newRoleValue)
          alert('角色修改成功')
          fetchUserList() // 重新加载列表
        } catch (error) {
          console.error('更新用户角色失败:', error)
          alert('角色修改失败，请稍后重试')
        } finally {
          loading.value = false
        }
      }
    }

    // 处理删除
    const handleDelete = async (user) => {
      console.log('删除用户:', user)
      if (confirm(`确定要删除用户 "${user.nickname}" 吗？`)) {
        try {
          loading.value = true
          await deleteUser(user.id)
          alert('删除成功')
          fetchUserList() // 重新加载列表
        } catch (error) {
          console.error('删除用户失败:', error)
          alert('删除失败，请稍后重试')
        } finally {
          loading.value = false
        }
      }
    }

    onMounted(() => {
      console.log('组件挂载完成，开始获取数据')
      fetchUserList()
    })

    return {
      userList,
      currentPage,
      totalPages,
      searchQuery,
      loading,
      handlePageChange,
      handleSearch,
      handleUpdateRole,
      handleDelete
    }
  }
}) 